<span class="badge" 
[class.badge-draft]="status === 1"
[class.badge-pending]="status === 2"
[class.badge-rejected]="status === 3"
[class.badge-completed]="status === 4"
[class.badge-removed]="status === 5"
[class.badge-canceled]="status === 6">
    {{ statusText }}
</span>